// extracted by mini-css-extract-plugin
export var sliderRange = "_q3-2";
export var sliderRoot = "_q3-0";
export var sliderThumb = "_q3-3";
export var sliderTrack = "_q3-1";